import { Helmet } from 'react-helmet-async';

const PageTitle = ({ title, description = 'Maxiom Wealth - Your Partner for Financial Growth' }) => {
  // Default title suffix
  const defaultTitle = ' | Maxiom Wealth';
  
  // If title is provided, append the default suffix, otherwise use the default title
  const fullTitle = title ? `${title}${defaultTitle}` : 'Maxiom Wealth';
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {/* Add any other meta tags you want to include on every page */}
    </Helmet>
  );
};

export default PageTitle;
